module.exports = __webpack_public_path__ + "assets/img/borino-glas.8acd2a4a.png";